(function() {
'use strict';

angular
    .module('core')
    .filter('unadjustedDate', unadjustedDate);

function unadjustedDate(dateFilter, dateUtil) {
    return (date, format) =>
        date == null
            ? undefined
            : dateFilter(dateUtil.parseDate(date), format);
}
})();
